import { useEffect, useState, useRef } from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../../../auth";
import funzione_collegamento from "../../../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../../../funzioni/differenza_ore";
import "../../../stili/tabelle.css";
import "../../../stili/popup.css";
import "../../../stili/tabs.css"
import convertDate from "../../../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../../../funzioni/nome_id.js"
import {
    convertiIdNoleggio,
    convertiValuta,
    convertiIdInventario,
    materialeDisponibile,
    analisiMateriale,
    sovrapposti,
    ordinaPerData,
    convertiTipoStorage,
    istruttori_disponibili, convertiColore, convertiTaglia, convertiIdEscursione
} from "../../../funzioni/funzioni_utili"
import TabellaLezioni from "../../../tabelle/lessons";
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPrint,faPencil, faFileInvoice,faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../../../assets/loading.json";
import {noleggi_off,utenti_off} from "../../../offline/offline_costanti.js";
import status_lezione from "../../../funzioni/status_lezione";
import NoleggiTabella from "../../../tabelle/noleggi";
import StorageTabella from "../../../tabelle/storageTab";
import RiparazioniTabella from "../../../tabelle/riparazioniTab";
import AccessoriTab from "../../../tabelle/maglie";
import EscursioniCli from "../../../tabelle/escursioniCli";
/* global $ */
function StoricoFatture() {
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
const traduzioni = {
    "Attrezzatura completa": "Full equipment",
    "Kite e barra": "Kite and bar",
    "Tavola twin tip": "Twin tip board",
    "Tavola surfino": "Surfboard",
    "Tavola foil": "Foil board",
    "Harness": "Harness",
    "Lycra e muta": "Lycra and wetsuit",
    "Caschetto e giubbotto": "Helmet and impact vest",
    "Twin tip - Surfino": "Twin tip - Surfboard",
    "Rossa": "Red",
    "Gialla": "Yellow",
    "Blu": "Blue",
    "Rosa": "Pink",
    "Bianca": "White",
    "Verde": "Green"
};

function DynamicLessonButton2({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);

          const righe = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
     filtri:{"invoiceid":cellInfo.data.invoiceid},
    azione:"getInvoiceRows",
  });
      const content=generaInterfacciaFattura(righe)
        $("#fattura").dxPopup("instance").option(
            "title",
            `Fattura`
          );
          $("#fattura").dxPopup("instance").option("contentTemplate", () => content);
          $("#fattura").dxPopup("instance").show();
          $("#fattura").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick: async function () {
                    const fatturaRich= await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        filtri:{getid:cellInfo.data.invoiceid},
                        azione:'generateInvoice'})

                    const datiFatture = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getInvoices",
            })
            let fatture=[]
            for (let fattura of datiFatture){
                fatture=[...fatture,{invoiceid:fattura.invoiceid,nome:fattura.invoicecustomer,indirizzo:fattura.invoiceaddress,data:convertDate(fattura.invoicedate).toISO({includeOffset:false}),
                contatti:fattura.invoicecontacts,note:fattura.invoicenotes,numero:fattura.invoicenumber,valore:fattura.invoicenetvalue,pagato:fattura.invoiceadvance,saldare:fattura.invoicetopay,valuta:fattura.invoicecurrency,link:fattura.invoicepdf
                }]
            }
            $("#gridContainerSpese").dxDataGrid("instance").option("dataSource",fatture)
            $("#fattura").dxPopup("instance").hide();

            }
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#fattura").dxPopup("instance").hide();
        },
      },
    }],)
          $("#loadingOverlay").hide();
            setLoading(false);
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faFileInvoice}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}
function generaInterfacciaFattura(righe){
    function aggiornaTotale(component) {
    const items = component.getDataSource().items();
    const totale = items.reduce(
        (acc, r) => acc + (parseFloat(r.invoicerownettotvalue) || 0),
        0
    );

    $("#totaleDiv").text("Totale: " + `${totale.toFixed(2)} €`);
}
    const divGen=document.createElement("div")
    const divRighe=document.createElement("div")
    const divTot=document.createElement("div")
    divTot.style.marginTop="10px"
    divTot.style.fontWeight="bold"
    divTot.style.fontSize="18px"
    divTot.style.fontFamily = "Poppins, sans-serif";
    divTot.id="totaleDiv"
    divRighe.id="righe"
    divGen.appendChild(divRighe)
    divGen.appendChild(divTot)
    setTimeout(()=> {
        $("#bottoneSalva").dxCheckBox({
            text:"Salva fattura",
            value:false,
        })
        $("#righe").dxDataGrid({
            dataSource:righe,
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: "Modifica intestazione",
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
            onRowRemoving: async function (e) {
                if (e.data.invoicerowid){
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.invoicerowid,
                azione:'delInvoiceRow',
                return_data:false})
            if (richiesta) {
                const message = `Conto eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerSpese',

                },}, "success", 500);}
        }},
            onRowUpdated: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.invoicerowid,
                azione:'setInvoiceRow',
            valori:e.data})
            if (richiesta) {
                const message = `Conto eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerSpese',

                },}, "success", 500);}
        },
            onRowInserting: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                azione:'setInvoiceRow',
            valori:e.newData})
            if (richiesta) {
                const message = `Conto eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerSpese',

                },}, "success", 500);}
        },
            columns:[
                {"dataField":"invoicerowdescr","caption":"Descrizione", hidingPriority:5},
                {"dataField":"invoicerowquant",caption:"Quantità",hidingPriority:2,
                editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_quantita_righe").length===0) {
                $('<div id="val_quantita_righe"></div>').appendTo(cellElement)
            }
            $("#val_quantita_righe").dxNumberBox({value:cellInfo.value,minValue:0,onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_unitario").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                { dataField: "invoicerowcurrency",visible:false, caption: "Valuta",hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta_righe").length===0) {
                $('<div id="val_valuta_righe"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta_righe").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_netto").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_unitario").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_gross").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)

            }})
          },
        },
                {"dataField":"invoicerownetunitvalue","caption":"Costo unitario",hidingPriority:3,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_unitario").length===0) {
                $('<div id="val_unitario"></div>').appendTo(cellElement)
            }
            $("#val_unitario").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_quantita_righe").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                {"dataField":"invoicerownettotvalue","caption":"Costo netto totale",hidingPriority:4,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_netto").length===0) {
                $('<div id="val_netto"></div>').appendTo(cellElement)
            }
            $("#val_netto").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_gross").dxNumberBox("instance").option("value",e.value)
            }})
          }
                },

                {"dataField":"invoicerowgrosstotvalue","caption":"Costo totale",hidingPriority:1,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_gross").length===0) {
                $('<div id="val_gross"></div>').appendTo(cellElement)
            }
            $("#val_gross").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

            ],
             onContentReady(e) {
        aggiornaTotale(e.component);
    },

    onCellValueChanged(e) {
        aggiornaTotale(e.component);
    },
            columnAutoWidth: true,
        columnHidingEnabled: true,
        })

    },0)
    return divGen

}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStoricoFatture() {
    const allineamento="center"
    useEffect(() => {
        const fetchStorages = async () => {
            $("#gridContainerSpese").addClass("grid-container-hidden")
            $("#loadingOverlay").show()
            const datiFatture = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getInvoices",
            })
            let fatture=[]
            for (let fattura of datiFatture){
                fatture=[...fatture,{invoiceid:fattura.invoiceid,nome:fattura.invoicecustomer,indirizzo:fattura.invoiceaddress,data:convertDate(fattura.invoicedate).toISO({includeOffset:false}),
                contatti:fattura.invoicecontacts,note:fattura.invoicenotes,numero:fattura.invoicenumber,valore:fattura.invoicenetvalue,pagato:fattura.invoiceadvance,saldare:fattura.invoicetopay,valuta:fattura.invoicecurrency,link:fattura.invoicepdf
                }]
            }

            $("#gridContainerSpese").dxDataGrid({

          dataSource: fatture,
        columns: [
             { dataField: "nome", alignment:allineamento,caption: "Nome Fattura",hidingPriority:9},
          {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },


          { dataField: "valore", alignment:allineamento,caption: "Importo Fattura", hidingPriority:6,calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.costo)val=rowData.costo
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`},
  },
            { dataField: "pagato", alignment:allineamento,caption: "Importo pagato", hidingPriority:5,calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.pagato)val=rowData.pagato
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`},
  },
            {
                dataField: "saldare", alignment:allineamento,caption: "Importo da saldare", hidingPriority:8,calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.pagato)val=rowData.pagato
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`},
  },
            { dataField: "indirizzo", alignment:allineamento,caption: "Indirizzo cliente",hidingPriority:2,
        },
            { dataField: "contatti", alignment:allineamento,caption: "contatti cliente",hidingPriority:3,
        },
        { dataField: "note", alignment:allineamento,caption: "Note fattura",hidingPriority:1,
        },
            { dataField: "numero", alignment:allineamento,caption: "Numero fattura",hidingPriority:4,
        },
            {dataField:"valuta",
            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }},

          {
            type: "buttons",
            minWidth:140,
            buttons: [
                {
                  hint: "Scarica Fattura",
                  icon: "none",
                  template: function (cellElement, cellInfo) {
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(<DynamicLessonButton2 cellInfo={cellInfo} />);
                  },
                },
                {
                hint: "Vedi fattura",
                icon: "none",
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPrint}
                      color="#dc3545"
                      onClick={() => {
                        const baseURL = "https://jckite.mogaverocompany.co.ke";
                    const fileURL = cellInfo.data.link?cellInfo.data.link.startsWith("http")
                        ? cellInfo.data.link
                        : `${baseURL}${cellInfo.data.link.startsWith("/") ? "" : "/"}${cellInfo.data.link}`:"";
                     window.open(fileURL, "_blank");
                      }
                    }
                    />
                  );
                },
              },
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },

              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
          ],
          showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica fattura",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },


        },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },

        onInitNewRow: function (e) {
              e.data.data=DateTime.now().toISO()
        },
        onRowInserting: async function (e) {
              let dati_n={invoicecustomer:e.data.nome,invoiceaddress:e.data.indirizzo,invoicedate:convertDate(DateTime.fromISO(e.data.data)),
                invoicecontacts:e.data.contatti,invoicenotes:e.data.note,invoicenumber:e.data.numero,invoicenetvalue:e.data.valore,invoiceadvance:e.data.pagato,invoicetopay:e.data.saldare,invoicecurrency:e.data.valuta,invoicepdf:e.data.link
                }
            let richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setInvoice'})
             const datiFatture = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getInvoices",
            })
            let fatture=[]
            for (let fattura of datiFatture){
                fatture=[...fatture,{invoiceid:fattura.invoiceid,nome:fattura.invoicecustomer,indirizzo:fattura.invoiceaddress,data:convertDate(fattura.invoicedate).toISO({includeOffset:false}),
                contatti:fattura.invoicecontacts,note:fattura.invoicenotes,numero:fattura.invoicenumber,valore:fattura.invoicenetvalue,pagato:fattura.invoiceadvance,saldare:fattura.invoicetopay,valuta:fattura.invoicecurrency,link:fattura.invoicepdf
                }]
            }
            $("#gridContainerSpese").dxDataGrid("instance").option("dataSource",fatture)

        },
        onRowUpdating: async function (e) {
            const gridElement = $("#gridContainerSpese"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            let dati_n={invoicecustomer:e.newData.nome,invoiceaddress:e.newData.indirizzo,invoicedate:e.newData.data?convertDate(DateTime.fromISO(e.newData.data)):convertDate(DateTime.fromISO(e.oldData.data)),
                invoicecontacts:e.newData.contatti,invoicenotes:e.newData.note,invoicenumber:e.newData.numero,invoicenetvalue:e.newData.valore,invoiceadvance:e.newData.pagato,invoicetopay:e.newData.saldare,invoicecurrency:e.newData.valuta,invoicepdf:e.newData.link
                }
            let richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.oldData.invoiceid,
                valori:dati_n,
                azione:'setInvoice'})
                if (richiesta) {
                const message = `Spesa modificata con successo`;
                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerSpese',

                        },}, "success", 500);
                const fatturaRich= await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        filtri:{getid:e.oldData.invoiceid},
                        azione:'generateInvoice'})
                const datiFatture = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getInvoices",
            })
            let fatture=[]
            for (let fattura of datiFatture){
                fatture=[...fatture,{invoiceid:fattura.invoiceid,nome:fattura.invoicecustomer,indirizzo:fattura.invoiceaddress,data:convertDate(fattura.invoicedate).toISO({includeOffset:false}),
                contatti:fattura.invoicecontacts,note:fattura.invoicenotes,numero:fattura.invoicenumber,valore:fattura.invoicenetvalue,pagato:fattura.invoiceadvance,saldare:fattura.invoicetopay,valuta:fattura.invoicecurrency,link:fattura.invoicepdf
                }]
            }
            $("#gridContainerSpese").dxDataGrid("instance").option("dataSource",fatture)
                }

            },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.invoiceid,
                azione:'delInvoice',
                return_data:false})
            if (richiesta) {
                const message = `Conto eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerSpese',

                },}, "success", 500);}
        },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerSpese").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
            if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo);
            if ((!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01)) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }

        },
          })
          $("#fattura").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
 showCloseButton:true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollFattura" style="height: 100%;"></div>');
    $("#customScrollFattura").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });
    $("#popupConto").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    showCloseButton:true,

    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollLista" style="height: 100%;"></div>');
    $("#customScrollLista").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });

        }
        fetchStorages()
    },[])
return (<div id="gridContainerSpese" ></div>)
}

return (<div>
        <TabellaStoricoFatture/>
        <div id="fattura"/>
    <div id="popupConto"/>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}

export default StoricoFatture